export default __webpack_public_path__ + "static/custommetadatamanagement-83f39bb75be290cf3cc5eee9d90373c2.svg";